import React from 'react';
import PropTypes from 'prop-types';
import NationalitySelector from '../../../../components/form/NationalitySelector.js';
import RadioButtonsGroup from '../../../../components/form/RadioButtonGroup';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {makeStyles} from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

const useStyles = makeStyles(() => ({
  otherTextField: {
    marginLeft: 58,
  },
  formControlNested: {
    marginLeft: 28
  },
  question: {
    paddingBottom: 15,
    fontWeight: 'bold',
    fontSize: 16
  },
  section: {
    marginTop: 15
  }
}));

const NationalityAndRace = (props) => {

  const {handleStepState, form} = props;
  const stepSlug = 'nationality-and-race';
  const classes = useStyles();

  const handleChange = event => handleStepState(stepSlug, {[event.target.name]: event.target.value});

  const handleParentChange = event => {
    handleStepState(stepSlug, {ethnicOrigin: ''});
    handleChange(event);

    if (['arab', 'other', 'preferNotToSay'].includes(form[stepSlug].data.ethnicOriginParent)) {
      handleChange({target: {name: 'ethnicOrigin', value: event.target.value}});
    }
  };

  const handleNationalityChange = (change) => {
    handleStepState(stepSlug, {...change});
  };

  return (
    <React.Fragment>
      <div className={classes.section}>
        <Typography component="h2" variant="h2">
          Nationality
        </Typography>
        <div className={classes.section}>
          <NationalitySelector handleChange={handleNationalityChange}
            nationalities={form[stepSlug].data.nationalities}
            otherNationalities={form[stepSlug].data.otherNationalities}
            label={'How would you describe your nationality? Select all that apply.'}
            showError={form[stepSlug].errors?.includes('otherNationalities')}
            errorMsg={form[stepSlug].errors?.includes('otherNationalities')? 'Please select at least one other nationality' : ''}
          />
        </div>
      </div>
      <div className={classes.section}>
        <Typography component="h2" variant='h2'>
          Race (ethnicity)
        </Typography>
        <div className={classes.section}>
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel
              component="legend"
              className={classes.question}
              data-testid="label-ethnicOrigin">What is your ethnic group? Choose one section, then choose one option that best describes your ethnic group or background.
            </FormLabel>
            <div
              className={form[stepSlug].errors && form[stepSlug].errors.findIndex(element => element.includes('ethnicOrigin')) !== -1 ? 'inline-error' : ''}>
              {form[stepSlug].errors && form[stepSlug].errors.findIndex(element => element.includes('ethnicOrigin')) !== -1 ?
                <p>If you do not wish to answer this question, please select ‘Prefer not to say’</p> : ''}

              <RadioGroup
                aria-label="ethnicOriginParent"
                name="ethnicOriginParent"
                value={form[stepSlug].data.ethnicOriginParent} onChange={(e) => handleParentChange(e)}>
                <FormControlLabel
                  value="white"
                  control={<Radio color="primary" />} label="White"
                  data-testid="ethnicOriginParent-select-option" />

                {form[stepSlug].data.ethnicOriginParent === 'white' ?
                  <div className={classes.formControlNested}>
                    <RadioButtonsGroup
                      label=""
                      name="ethnicOrigin"
                      options={[
                        {id: 'whiteBritish', name: 'White – English / Welsh / Scottish / Northern Irish / British'},
                        {id: 'whiteIrish', name: 'White - Irish'},
                        {id: 'whiteGypsyTraveller', name: 'White – Gypsy or Irish Traveller'},
                        {id: 'whiteRoma', name: 'White – Roma'},
                        {id: 'otherWhite', name: 'White – Any other White background'}
                      ]}
                      value={form[stepSlug].data.ethnicOrigin}
                      handleChange={(e) => handleChange(e)}
                    />
                  </div>
                  : null}

                <FormControlLabel
                  value="mixed" control={<Radio color="primary" />} label="Mixed / Multiple ethnic groups"
                  data-testid="ethnicOriginParent-select-option" />
                {form[stepSlug].data.ethnicOriginParent === 'mixed' ?
                  <div className={classes.formControlNested}>
                    <RadioButtonsGroup
                      label=""
                      name="ethnicOrigin"
                      options={[
                        {id: 'mixWhiteBlackCaribbean', name: 'Mixed – White and Black Caribbean'},
                        {id: 'mixWhiteBlackAfrican', name: 'Mixed – White and Black African'},
                        {id: 'mixWhiteAsian', name: 'Mixed – White and Asian'},
                        {id: 'otherMix', name: 'Mixed – Any other Mixed / Multiple ethnic background'}
                      ]}
                      value={form[stepSlug].data.ethnicOrigin}
                      handleChange={(e) => handleChange(e)}
                    />
                  </div>
                  : null}

                <FormControlLabel
                  value="asian" control={<Radio color="primary" />} label="Asian / Asian British"
                  data-testid="ethnicOriginParent-select-option" />
                {form[stepSlug].data.ethnicOriginParent === 'asian' ?
                  <div className={classes.formControlNested}>
                    <RadioButtonsGroup
                      label=""
                      name="ethnicOrigin"
                      options={[
                        {id: 'asianAsianBritishBritish', name: 'Asian – English / Welsh / Scottish / Northern Irish / British'},
                        {id: 'asianAsianBritishIndian', name: 'Asian - Indian'},
                        {id: 'asianAsianBritishPakistani', name: 'Asian - Pakistani'},
                        {id: 'asianAsianBritishBangladeshi', name: 'Asian - Bangladeshi'},
                        {id: 'asianAsianBritishChinese', name: 'Asian - Chinese'},
                        {id: 'otherAsianAsianBritish', name: 'Asian – Any other Asian background'}
                      ]}
                      value={form[stepSlug].data.ethnicOrigin}
                      handleChange={(e) => handleChange(e)}
                    />
                  </div>
                  : null}

                <FormControlLabel
                  value="black" control={<Radio color="primary" />} label="Black / African / Caribbean / Black British"
                  data-testid="ethnicOriginParent-select-option" />
                {form[stepSlug].data.ethnicOriginParent === 'black' ?
                  <div className={classes.formControlNested}>
                    <RadioButtonsGroup
                      label=""
                      name="ethnicOrigin"
                      options={[
                        {id: 'blackBlackBritishBritish', name: 'Black – English / Welsh / Scottish / Northern Irish / British'},
                        {id: 'blackBlackBritishAfrican', name: 'Black - African'},
                        {id: 'blackBlackBritishCaribbean', name: 'Black - Caribbean'},
                        {id: 'blackBlackBritishOther', name: 'Black – Any other Black / African / Caribbean / Black British background'}
                      ]}
                      value={form[stepSlug].data.ethnicOrigin}
                      handleChange={(e) => handleChange(e)}
                    />
                  </div>
                  : null}

                <FormControlLabel
                  value="otherEthnicGroup" control={<Radio color="primary" />} label="Other ethnic group"
                  data-testid="ethnicOriginParent-select-option" />
                {form[stepSlug].data.ethnicOriginParent === 'otherEthnicGroup' ?
                  <div className={classes.formControlNested}>
                    <RadioButtonsGroup
                      label=""
                      name="ethnicOrigin"
                      options={[
                        {id: 'arab', name: 'Other - Arab'},
                        {id: 'other', name: 'Other – Any other ethnic group'},
                      ]}
                      value={form[stepSlug].data.ethnicOrigin}
                      handleChange={(e) => handleChange(e)}
                    />
                  </div>
                  : null}

                <FormControlLabel
                  value="preferNotToSay" control={<Radio color="primary" />} label="Prefer not to say"
                  data-testid="ethnicOriginParent-select-option" />
              </RadioGroup>
            </div>
          </FormControl>
        </div>
      </div>
    </React.Fragment>
  );
};
NationalityAndRace.propTypes = {
  handleStepState: PropTypes.func,
  form: PropTypes.object,
  step: PropTypes.object,
};
export default NationalityAndRace;
